export default __webpack_public_path__ + "static/media/Star 8 (1).00a91886.svg";